export default "__VITE_ASSET__BKUEllJm__"